module.exports = __webpack_public_path__ + "static/media/Colette Wing King Headboard - 180 cm_Grey.267f24b1.png";